var ko = require('knockout');

function Model(params) {
  this.text = params.text;
  this.buttonText = window.language.readMore;

  this.isVisible = ko.observable();

  this.show = function() {
    this.isVisible(true);
  }.bind(this);

  this.hide = function() {
    this.isVisible(false);
  }.bind(this);
}

module.exports = Model;
